<template>
  <span>    
    <v-icon :style="{color,cursor:'help'}" :title="$t(`GliderWaitingMode.${waitingMode}`)">mdi-brightness-1</v-icon>
    <v-menu v-show="alarmStatus.length && alarmStatus[0] != 'Ok'" open-on-hover offset-y>
      <span class="alert pl-2" slot="activator">!</span>      
      <v-list>
        <span class="notification subheading pl-3">{{$t('App.Notifications')}}</span>
        <v-list-tile v-for="alarmKey in alarmStatus" :key="alarmKey">
          <v-list-tile-title>{{ $t(`CodeAlarm.${alarmKey}`) }}</v-list-tile-title>
          <v-spacer></v-spacer>
          <v-list-tile-action style="justify-content:flex-end">
            <v-btn icon title="Clear Alarm" @click.stop.prevent=""><v-icon>mdi-close</v-icon></v-btn>
          </v-list-tile-action>
        </v-list-tile>
      </v-list>
    </v-menu>
  </span>
</template>
<script lang="ts">      
  import { gliderWaitingModesColor, GLIDER_MODE } from '@/models/alo/AloMission'      
  import Vue from 'vue'  
  import Component from 'vue-class-component'  

  @Component({
    name: 'ItemState', 
    props:{      
      waitingMode: String,
      alarmStatus: Array
    }
  })
  export default class ItemState extends Vue {  
    waitingMode!:GLIDER_MODE
    
    get color() {
      return gliderWaitingModesColor[this.waitingMode]
    }
  }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.alert{
  font-weight: bolder;
  font-size: 26px;
  line-height: 21px;
  color:#ff0000;
  top:-2px;
  position: relative;
}
.notification{
  color:#ff0000
}
</style>
